import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface RegistroPopupProps {
  onClose: () => void;
  onCreate: (
    nombre: string,  // Cambié 'name' por 'nombre' aquí para reflejar el cambio
    date: string,
    testigo1: string,
    testigo2: string,
    jefe: string,
    descargo: string,
    estado: string,
    files: File | null
  ) => Promise<void>;
}

const NewDischargePopup: React.FC<RegistroPopupProps> = ({ onClose, onCreate }) => {
  const [formValues, setFormValues] = useState({
    nombre: '', // Cambié 'name' por 'nombre'
    date: '',
    testigo1: '',
    testigo2: '',
    jefe: '',
    descargo: '',
    estado: 'abierto',
    files: null as File | null,
  });

  const [empleados, setEmpleados] = useState<string[]>([]); // Estado para almacenar empleados

  // Obtener lista de empleados al cargar el componente
  useEffect(() => {
    const fetchEmpleado = async () => {
      try {
        const response = await axios.get('http://localhost:3004/api/usuarios'); // Cambia esta URL según tu API
        // Supongamos que la respuesta es un array de objetos con la propiedad "nombre"
        const empleadosNombres = response.data.map((empleado: { nombre: string }) => empleado.nombre);
        setEmpleados(empleadosNombres); // Aquí solo almacenamos los nombres de los empleados
      } catch (error) {
        console.error('Error al obtener empleados:', error);
        toast.error('Error al obtener la lista de empleados');
      }
    };

    fetchEmpleado();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    for (const key in formValues) {
      if (formValues[key as keyof typeof formValues] === '' && key !== 'files') {
        toast.error(`El campo ${key} es requerido.`);
        return;
      }
    }

    const formData = new FormData();
    for (const key in formValues) {
      if (formValues[key as keyof typeof formValues] !== null) {
        formData.append(key, formValues[key as keyof typeof formValues] as any);
      }
    }

    try {
      const response = await axios.post('http://localhost:3004/descargos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Respuesta del servidor:', response);
      if (response.status === 200) {
        console.log('Formulario enviado:', response.data);
        toast.success('Datos enviados con éxito');
        handleClear();
        setTimeout(onClose, 4000);
      } else {
        toast.error('Hubo un error con la respuesta del servidor');
      }
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      toast.error(`Hubo un error al enviar los datos: ${(error as Error).message}`);
    }
  };

  const handleClear = () => {
    setFormValues({
      nombre: '', // Cambié 'name' por 'nombre'
      date: '',
      testigo1: '',
      testigo2: '',
      jefe: '',
      descargo: '',
      estado: 'abierto',
      files: null,
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    if (e.target.name === 'files') {
      const file = (e.target as HTMLInputElement).files?.[0] || null;
      setFormValues({ ...formValues, [e.target.name]: file });
    } else {
      setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-3xl relative">
        {/* Botón de cerrar en la esquina */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl text-gray-500 hover:text-gray-800"
        >
          &times;
        </button>
        
        <h2 className="text-lg font-bold mb-4">Registro de diligencia de descargos</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Fecha</label>
              <input
                type="date"
                name="date"
                value={formValues.date}
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Nombre de Empleado</label>
              <select
                name="nombre" // Cambié 'name' por 'nombre' aquí
                value={formValues.nombre} // Cambié 'name' por 'nombre'
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
              >
                <option value="">Seleccione un empleado</option>
                {empleados.map((nombre, index) => (
                  <option key={index} value={nombre}>
                    {nombre}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Nombre del Testigo 1</label>
              <input
                type="text"
                name="testigo1"
                value={formValues.testigo1}
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Nombre del Testigo 2</label>
              <input
                type="text"
                name="testigo2"
                value={formValues.testigo2}
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Jefe Inmediato</label>
              <input
                type="text"
                name="jefe"
                value={formValues.jefe}
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Descripcion del Descargo</label>
              <textarea
                name="descargo"
                value={formValues.descargo}
                onChange={handleChange}
                required
                className="border p-2 rounded-lg w-full"
                rows={4}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Estado</label>
              <select
                name="estado"
                value={formValues.estado}
                onChange={handleChange}
                className="border p-2 rounded-lg w-full"
              >
                <option value="abierto">Abierto</option>
                <option value="cerrado">Cerrado</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Pruebas</label>
              <input
                type="file"
                name="files"
                onChange={handleChange}
                className="border p-2 rounded-lg w-full"
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
              Enviar
            </button>
            <button type="button" onClick={handleClear} className="bg-red-500 text-white px-4 py-2 rounded">
              Borrar Todo
            </button>
            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
      <ToastContainer 
        position="top-right" 
        autoClose={5000} 
        hideProgressBar={false} 
        closeOnClick 
        pauseOnHover 
        draggable 
        pauseOnFocusLoss 
        style={{ marginTop: '100px' }} 
      />
    </div>
  );
};

export default NewDischargePopup;
